import React from 'react';

import { Tooltip } from '@mui/material';
import { Magnify as SearchIcon } from '@opengov/react-capital-assets';

import { ActionButton } from '../../Components/ActionButton';
import { tooltipOffsetProps } from '../../Components/styleConstants';
import { DATA_OG, DATA_TEST } from '../../enums';

interface ISearchActionButtonProps {
  condensed?: boolean;
  showCondensedLabel?: boolean;
  onClick(): void;
}

export const SearchActionButton: React.FC<ISearchActionButtonProps> = ({
  onClick,
  condensed = false,
  showCondensedLabel
}) => {
  const searchLabel = 'Search';
  return (
    <Tooltip
      title={condensed && !showCondensedLabel ? searchLabel : ''}
      placement="top"
      enterNextDelay={500}
      disableInteractive={true}
      {...tooltipOffsetProps}
    >
      <div style={{ display: 'inline-flex' }}>
        <ActionButton
          dataTest={DATA_TEST.search_action_button}
          dataOg={DATA_OG.search_action_button}
          accessibility={{}}
          IconPrefix={SearchIcon}
          onClick={onClick}
          label={!condensed || showCondensedLabel ? searchLabel : ''}
          slots={{
            icon: {
              styleProps: {
                ...(condensed && { fontSize: '1.5rem' })
              }
            },
            button: {
              styleProps: {
                ...(condensed && { height: 32, marginY: 1, marginX: 0 }),
                ...(condensed && !showCondensedLabel && { width: 32 }),
                minWidth: '0 !important',
                height: 32,
                ...((!condensed || showCondensedLabel) && { py: 1, pl: 0.5, pr: 1 })
              }
            }
          }}
        />
      </div>
    </Tooltip>
  );
};
